<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center m-0" id="page-login">
    <div class="vx-col sm:w-3/4 md:w-3/4 lg:w-3/4 xl:w-3/4 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden md:hidden lg:block lg:w-5/12 left" style="height: 90vh; min-height: 500px">
              <div class="mt-2">
                <div class="container">
                  <div class="vx-row mt-6">
                    <div class="vx-col w-full">
                      <img src="@/assets/images/logo/icon.png" style="width: 150px;">
                    </div>
                  </div>

                  <div class="vx-row" style="margin-top: vh;">
                    <div class="vx-col w-full">
                      <span>
                        <p class="text-login text-center">Khám phá hàng triệu</p>
                        <br/>
                        <p class="text-login text-center">sắc thái trên internet đang</p>
                        <br/>
                        <p class="text-login text-center">nói về thương hiệu của bạn</p>
                      </span>
                    </div>
                  </div>

                  <div class="vx-row" style="margin-top: 5vh">
                    <div class="vx-col w-full">
                      <p class="description text-center">Hàng ngày chúng tôi quét gần 13 tỷ nguồn tin trên </p>
                      <br/>
                      <p class="description text-center">internet và mạng xã hội để cung cấp thông tin cho</p>
                      <br/>
                      <p class="description text-center">bạn để bạn có hành động kịp thời</p>
                    </div>
                  </div>

                  <vs-row>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8"
                            class="sm:p-2 p-4">
                      <div class="vx-card p-4" style="border-radius: 20px; margin-top: 25vh; height: 13vh">
                        <div class="vx-row">
                          <div class="vx-col mt-2" style="margin:auto; font-size:15px">
                            <span class="font-semibold">Bạn đã có tài khoản?</span>
                          </div>
                        </div>

                        <div class="vx-row">
                          <div class="vx-col mt-2" style="margin:auto;">
                            <vs-button style="border-radius:20px" color="primary" type="gradient" icon-pack="feather"
                                       icon="icon-chevron-right" @click="login">Đăng nhập
                            </vs-button>
                          </div>
                        </div>
                      </div>
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-7/12 vs-lg:2" style="padding: 0 10%">
              <div class="vx-row pt-3">
                <div class="vx-col w-full">
                  <h1 class="text-center">Yêu cầu bản dùng thử</h1>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col mt-8 w-full">
                  <label><h4>Tên của bạn</h4></label>
                </div>
                <div class="vx-col mt-2 w-full">
                  <vs-input
                    class="w-full vs-input-no-border vs-input-no-shdow-focus grey-color"
                    v-validate="'required|min:3'"
                    data-vv-validate-on="blur"
                    type="account"
                    name="fullName"
                    v-model="user.fullName"
                    autocomplete="off"
                  ></vs-input>
                  <span class="text-danger text-sm">{{
                      errors.first("fullName")
                    }}</span>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col mt-8 w-full">
                  <label><h4>Địa chỉ email</h4></label>
                </div>

                <div class="vx-col mt-2 w-full">
                  <vs-input
                    class="w-full vs-input-no-border vs-input-no-shdow-focus grey-color"
                    v-validate="'required|email'"
                    data-vv-validate-on="blur"
                    type="email"
                    name="email"
                    v-model="user.email"
                    autocomplete="off"
                  ></vs-input>
                  <span class="text-danger text-sm">{{
                      errors.first("email")
                    }}</span>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col mt-8 w-full">
                  <label><h4>Số điện thoại</h4></label>
                </div>

                <div class="vx-col mt-2 w-full">
                  <vs-input
                    class="w-full vs-input-no-border vs-input-no-shdow-focus grey-color"
                    v-validate="'required|numeric|min:10|max:11'"
                    data-vv-validate-on="blur"
                    type="number"
                    name="phoneNumber"
                    v-model="user.phoneNumber"
                    autocomplete="off"
                  ></vs-input>
                  <span class="text-danger text-sm">{{
                      errors.first("phoneNumber")
                    }}</span>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col mt-8 w-full">
                  <label><h4>Lĩnh vực của bạn</h4></label>
                </div>

                <div class="vx-col mt-2 w-full">
                  <vs-input
                    class="w-full vs-input-no-border vs-input-no-shdow-focus grey-color"
                    v-validate="'min:3'"
                    data-vv-validate-on="blur"
                    type="text"
                    name="businessTarget"
                    v-model="user.businessTarget"
                    autocomplete="off"
                  ></vs-input>
                  <span class="text-danger text-sm">{{
                      errors.first("businessTarget")
                    }}</span>
                </div>
              </div>
              <div class="vx-row mt-8">
                <div class="vx-col w-full text-center">
                  <vs-button @click="registerUser">Gửi yêu cầu</vs-button>
                </div>
              </div>
              <div class="vx-row mt-8">
                <div class="vx-col md:w-1/2 w-full text-right">
                  <span>Chính sách bảo mật</span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <span>Điều khoản sử dụng</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
  import province from '@/assets/utils/province.js';
  import image from '../../../assets/images/logo/back-ground-left.png';

  export default {
    components: {
      province
    },
    data() {
      return {
        checkBox: false,
        registerSuccess: 0,
        genderOptions: [
          {value: 0, label: 'Khác'},
          {value: 1, label: 'Nữ'},
          {value: 2, label: 'Nam'}
        ],
        cityOptions: province.getProvince(),
        districtOptions: province.getDistrict(),
        subDistrictOptions: province.getSubDistrict(),
        user: {
          gender: null,
          city: null,
          district: null,
          subDistrict: null,
          address: null,
          houseNumber: null,
          password: "",
          rePassword: ""
        },
      }
    },
    methods: {
      login: function () {
        this.$router.push('/pages/login').catch(() => {
        });
      },
      async registerUser(evt) {

        evt.preventDefault();
        if (!this.validateForm) return;

        const result = await this.$validator.validateAll();
        if (!result) return;
        this.$vs.loading();
        this.$business.post('/business-user/request-demo', [this.user]).then((response) => {
          this.registerSuccess = 1;
          this.$vs.loading.close();
          this.$vs.notify({
            text: 'Gửi yêu cầu thành công, bộ phận CSKH sẽ liên hệ với bạn trong ít phút.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'primary'
          });
          this.$router.push('/pages/login').catch(() => {
          });
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      }
    },
    computed: {
      validateForm() {
        return !this.errors.any();
      },
      genderModel: {
        get() {
          let obj = this.genderOptions.find(x => x.value === this.user.gender);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.user.gender
          }
        },
        set(obj) {
          this.user.gender = obj.value;
        }
      },
      province: {
        get() {
          let obj = this.cityOptions.find(x => x.value === this.user.city);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.user.city
          }
        },
        set(obj) {
          this.user.city = obj.value;
          this.districtOptions = province.getDistrict(obj.value);
          this.user.district = this.districtOptions[0].value;
          this.subDistrictOptions = province.getSubDistrict(this.user.city, this.user.district);
          this.user.subDistrict = this.subDistrictOptions[0].value;
        }
      },
      district: {
        get() {
          let obj = this.districtOptions.find(x => x.value === this.user.district);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.user.district
          }
        },
        set(obj) {
          this.user.district = obj.value;
          this.subDistrictOptions = province.getSubDistrict(this.user.city, obj.value);
          this.user.subDistrict = this.subDistrictOptions[0].value;
        }
      },
      subDistrict: {
        get() {
          let obj = this.subDistrictOptions.find(x => x.value === this.user.subDistrict);
          if (!obj) {
            return null;
          }
          return {
            label: obj.label,
            value: this.user.subDistrict
          }
        },
        set(obj) {
          this.user.subDistrict = obj.value
        }
      },
      fullAddressModel: {
        get() {
          let houseNumber = `${this.user.houseNumber ? this.user.houseNumber + ', ' : ''}`
          let subDistrict = `${this.subDistrict && this.subDistrict.label ? this.subDistrict.label + ', ' : ''}`
          let district = `${this.district && this.district.label ? this.district.label + ", " : ''}`
          let province = `${this.province && this.province.label ? this.province.label : ''}`;
          /* eslint-disable */
          this.user.fullAddress = houseNumber + subDistrict + district + province;
          return this.user.fullAddress;
        },
      }
    }
  }
</script>
<style scoped>
  .logo {
    position: absolute;
    top: 20px;
    left: 20px
  }

  .text-login {
    color: rgb(241, 235, 235);
    font-weight: bold;
    font-size: 28px;
    line-height: 10px;
  }

  .description {
    color: rgb(241, 235, 235);
    font-size: 14px;
    line-height: 0;
  }

  .left {
    background-image: url('../../../assets/images/logo/back-ground-left.png');
    width: 100%;
    background-repeat: no-repeat;
    background-size: auto;
    height: auto;
  }

  .card-buttom {
    min-width: 200px;
    height: 80px;
    margin: auto;
    max-width: 250px;
    position: absolute;
    left: 12%;
    bottom: 10%
  }

  .login-info {
    font-size: 40px;
  }

  .border-bottom {
    border-bottom: 1px solid #ccc;
  }

  .grey-color {
    background-color: #EBEBEB;
    padding: 9px;
  }

  .vs-con-input-label {
    border-radius: 20px;
    height: 50px;
  }
</style>
